import(/* webpackMode: "eager", webpackExports: ["default"] */ "/calcom/apps/web/app/(use-page-wrapper)/(main-nav)/availability/skeleton.tsx");
